import geofencesActions from '@state/geofences/actions';
import * as defaultAlarms from '@pages/Alertas/helpers/defaultAlerts/alertsNames';

import constants from './constants';

// const initOrCondition = {
//   type: 'numeric_threshold',
//   params: {},
// };

const initOrCondition = {
  type: 1,
  // field: '',
  // values: [],
};

const setCreateEditDevice = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_CREATE_EDIT_DEVICES,
    payload: values,
  });

};

const setDeviceIdEdit = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_DEVICES_ID_TO_EDIT,
    payload: values,
  });

};

const setIdBusinessType = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_ID_BUSINESS_TYPE,
    payload: values,
  });

};

const setCreateEditGateway = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_CREATE_EDIT_GATEWAY,
    payload: values,
  });

};

const setGatewayIdEdit = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_GATEWAY_ID_TO_EDIT,
    payload: values,
  });

};

const setDeviceLogs = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_DEVICES_LOGS,
    payload: values,
  });

};
function setIsEditDefault({ name, forceIsEdit = null } = {}) {

  const isEditDefault = Object.values(defaultAlarms).includes(name);
  return {
    type: constants.SET_IS_EDIT_DEFAULT,
    payload: forceIsEdit === null ? isEditDefault : forceIsEdit,
  };

}

function setCreateEditValues(values) {

  return {
    type: constants.SET_CREATE_EDIT_VALUES,
    payload: values,
  };

}

function addCreateEditValuesGroupConditions() {

  return (dispatch, getState) => {

    const {
      device: { createEditValues },
    } = getState();

    const { conditions } = createEditValues;
    if (conditions === undefined) return;

    const newConditions = [...conditions, []];
    const newCreateEditValues = { ...createEditValues, conditions: newConditions };

    dispatch({
      type: constants.ADD_CREATE_EDIT_VALUES_GROUP_CONDITIONS,
      payload: newCreateEditValues,
    });

  };

}

function removeCreateEditValuesGroupConditions(index) {

  return (dispatch, getState) => {

    const {
      device: { createEditValues },
    } = getState();

    const { conditions } = createEditValues;
    if (conditions === undefined) return;

    const newConditions = [...conditions];
    newConditions.splice(index, 1);
    const newCreateEditValues = { ...createEditValues, conditions: newConditions };

    dispatch({
      type: constants.REMOVE_CREATE_EDIT_VALUES_GROUP_CONDITIONS,
      payload: newCreateEditValues,
    });

  };

}

function addOrCondition(index, values = initOrCondition) {

  return (dispatch, getState) => {

    const {
      device: { createEditValues },
    } = getState();

    const { conditions } = createEditValues;
    if (conditions === undefined) return;

    const newConditions = [...conditions];
    newConditions[index] = [...newConditions[index], values];
    const newCreateEditValues = { ...createEditValues, conditions: newConditions };

    dispatch({
      type: constants.ADD_CREATE_EDIT_VALUES_OR_CONDITION,
      payload: newCreateEditValues,
    });

  };

}

function removeOrCondition(groupIndex, conditionIndex) {

  return (dispatch, getState) => {

    const {
      device: { createEditValues },
    } = getState();

    const { conditions } = createEditValues;
    if (conditions === undefined) return;

    const newConditions = [...conditions];
    newConditions[groupIndex].splice(conditionIndex, 1);
    const newCreateEditValues = { ...createEditValues, conditions: newConditions };

    dispatch({
      type: constants.REMOVE_CREATE_EDIT_VALUES_OR_CONDITION,
      payload: newCreateEditValues,
    });

  };

}

function changeOrCondition(groupIndex, conditionIndex, values) {

  return (dispatch, getState) => {

    const {
      device: { createEditValues },
    } = getState();

    const { conditions } = createEditValues;
    if (conditions === undefined) return;

    const newConditions = [...conditions];
    newConditions[groupIndex][conditionIndex] = values;
    const newCreateEditValues = { ...createEditValues, conditions: newConditions };

    dispatch({
      type: constants.CHANGE_CREATE_EDIT_VALUES_OR_CONDITION,
      payload: newCreateEditValues,
    });

  };

}

function addCreateEditValuesAction(initAction) {

  return (dispatch, getState) => {

    const {
      device: { createEditValues },
    } = getState();

    const { actions } = createEditValues;
    if (actions === undefined) return;

    const newActions = [...actions, initAction];
    const newCreateEditValues = { ...createEditValues, actions: newActions };

    dispatch({
      type: constants.ADD_CREATE_EDIT_VALUES_ACTION,
      payload: newCreateEditValues,
    });

  };

}

function removeCreateEditValuesAction(index) {

  return (dispatch, getState) => {

    const {
      device: { createEditValues },
    } = getState();

    const { actions } = createEditValues;
    if (actions === undefined) return;

    const newActions = [...actions];
    newActions.splice(index, 1);
    const newCreateEditValues = { ...createEditValues, actions: newActions };

    dispatch({
      type: constants.REMOVE_CREATE_EDIT_VALUES_ACTION,
      payload: newCreateEditValues,
    });

  };

}

function changeCreateEditValuesAction(index, values) {

  return (dispatch, getState) => {

    const {
      device: { createEditValues },
    } = getState();

    const { actions } = createEditValues;
    if (actions === undefined) return;

    const newActions = [...actions];
    newActions[index] = values;
    const newCreateEditValues = { ...createEditValues, actions: newActions };

    dispatch({
      type: constants.CHANGE_CREATE_EDIT_VALUES_ACTION,
      payload: newCreateEditValues,
    });

  };

}

function setSimpleAlarmsList(value) {

  return { type: constants.SET_DEVICE_LIST, payload: value };

}

function setAlarmsList({ count, results, preventAppend = false } = {}) {

  return (dispatch, getState) => {

    const {
      offset,
      // deviceList,
      limit,
    } = getState().device;
    const newOffset = offset + limit;
    const newAlarmsList = results;
    // const newAlarmsList = deviceList && offset !== 0 ? [...deviceList, ...results] : results;
    dispatch({
      type: constants.SET_DEVICES_LIST,
      payload: {
        offset: newOffset,
        deviceList: newAlarmsList,
        count,
      },
    });

  };

}

function addAlarmToListOrSumCount(newAlarm) {

  return (dispatch, getState) => {

    const { deviceList, count, search } = getState().device;
    if (!count) return;

    dispatch(geofencesActions.resetState());

    if (search.length > 0) {

      dispatch({ type: constants.RESET_DEVICES });
      return;

    }

    const isFull = deviceList ? deviceList.length === count : false;
    const newCount = count + 1;

    if (isFull) {

      const newAlarmsList = [...deviceList, newAlarm];

      dispatch({
        type: constants.ADD_DEVICE,
        payload: {
          deviceList: newAlarmsList,
          count: newCount,
        },
      });

      return;

    }

    dispatch({
      type: constants.SET_DEVICE_COUNT,
      payload: newCount,
    });

  };

}

function editAlarm(editedAlarm) {

  return (dispatch, getState) => {

    const { deviceList } = getState().device;
    if (!deviceList) return;

    const alarmToEditIndex = deviceList.findIndex((alarm) => alarm.id === editedAlarm.id);
    if (alarmToEditIndex === -1) return;

    const newAlarmsList = [...deviceList];
    newAlarmsList[alarmToEditIndex] = editedAlarm;

    dispatch(geofencesActions.resetState());

    dispatch({
      type: constants.EDIT_DEVICE,
      payload: newAlarmsList,
    });

  };

}

function startDeletingAlarm(id) {

  return (dispatch, getState) => {

    const { idsInDeleting } = getState().device;
    const newIdsInDeleting = [...idsInDeleting, id];
    dispatch({
      type: constants.START_DELETING_DEVICE,
      payload: newIdsInDeleting,
    });

  };

}

function deleteAlarm(id) {

  return (dispatch, getState) => {

    const { deviceList, count, idsInDeleting } = getState().device;
    if (!deviceList) return;

    const alarmIndex = deviceList.findIndex((alarm) => alarm.id === id);
    const deleteIndex = idsInDeleting.indexOf(id);

    if (alarmIndex === -1) return;

    const newAlarmsList = [...deviceList];
    newAlarmsList.splice(alarmIndex, 1);
    const newCount = count ? count - 1 : count;

    const newIdsInDeleting = idsInDeleting.slice();
    if (deleteIndex !== -1) newIdsInDeleting.splice(deleteIndex, 1);

    dispatch(geofencesActions.resetState());

    dispatch({
      type: constants.DELETE_DEVICE,
      payload: {
        deviceList: newAlarmsList,
        count: newCount,
        idsInDeleting: newIdsInDeleting,
      },
    });

  };

}

function resetOffset() {

  return { type: constants.RESET_OFFSET };

}

function setSearch(value) {

  return { type: constants.SET_SEARCH, payload: value };

}

export default {
  setIsEditDefault,
  setCreateEditValues,
  setCreateEditGateway,
  setGatewayIdEdit,
  addCreateEditValuesGroupConditions,
  removeCreateEditValuesGroupConditions,
  addOrCondition,
  removeOrCondition,
  changeOrCondition,
  addCreateEditValuesAction,
  removeCreateEditValuesAction,
  changeCreateEditValuesAction,
  setAlarmsList,
  addAlarmToListOrSumCount,
  editAlarm,
  deleteAlarm,
  resetOffset,
  setSearch,
  startDeletingAlarm,
  setCreateEditDevice,
  setDeviceIdEdit,
  setIdBusinessType,
  setDeviceLogs,
  setSimpleAlarmsList,
};
